angular.module('picmonicng').directive('plsToggle', [
  function () {
    return {
      restrict: 'A',
      scope: {
        plsToggle: '=',
      },
      link: function (scope, element) {
        element.bind('click', function () {
          scope.$apply(function () {
            scope.plsToggle = !scope.plsToggle;
          });
        });

        element.bind('keypress', function (e) {
          if (e.charCode == 13) {
            scope.$apply(function () {
              scope.plsToggle = !scope.plsToggle;
            });
          }
        });
      },
    };
  },
]);
